/* eslint-disable no-unused-vars */
import { Box, Button, Card, Container, Grid, Stack, styled, Typography } from "@mui/material";
import Headers from "../components/Headers/Headers"
import Layout from "../components/Layout/Layout"
import { Helmet } from "react-helmet-async";

const CustomCard = styled(Grid)(({ theme }) => ({
  backgroundColor: "rgb(245,245,245)",
  width: "100%",
  textAlign: "left",
  padding: theme.spacing(3)


}));


const TitleTextOther = styled(Typography)(({ theme }) => ({
  textTransform: "uppercase",
  fontWeight: 700,
}));

function Kontakty() {
  return (
    <>
      <Helmet>
        <title>RS Rent Kontakt | Stěhovací služby a půjčovna vozů</title>
        <meta name="description" content="Nabízíme profesionální stěhovací služby a půjčovnu vozů. Přestěhujeme vás rychle a bezpečně za skvělé ceny. RSrent.cz - váš partner pro stěhování." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://rsrent.cz/kontakt" />
      </Helmet>
      <Layout>
        <Headers>Kontakt</Headers>
        <Container maxWidth="lg" sx={{
          my: 10
        }}>
          <Grid container gap={1} sx={{

          }}>
            <CustomCard item xs={12} sx={{
              textAlign: "center"
            }}>
              <Stack gap={2}>
                <Box>
                  <TitleTextOther variant="body1"
                  >
                    Objednávky - telefonicky
                  </TitleTextOther>
                  <Typography component="a" href='tel:+420777276064' variant="h3" color="secondary" sx={{
                    "&:hover": {
                      color: "primary.main",
                      cursor: "pointer"
                    }
                  }}>777 276 064</Typography>
                </Box>
                <Typography variant="subtitle1">PO-PA 19-20:00</Typography>
              </Stack>
            </CustomCard>
            <CustomCard item xs={12} md={6} sx={{
              backgroundColor: "primary.main",
              color: "white"
            }}>
              <Stack>
                <TitleTextOther variant="subtitle1" >Email</TitleTextOther>
                <Typography href='mailto: info@rsrent.cz' component={"a"} variant="body1" >info@rsrent.cz</Typography>
              </Stack>
            </CustomCard>
            <CustomCard item xs={12} md sx={{
              backgroundColor: "primary.main",
              p: 3,
              color: "white",
            }}>
              <Stack>
                <TitleTextOther variant="body1">Online formulář</TitleTextOther>
                <Button variant="contained" size="small" color="secondary">
                  Rezervovat online
                </Button>
              </Stack>
            </CustomCard>
          </Grid>
        </Container>
      </Layout>
    </>
  )
}

export default Kontakty